class Menu {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.ui.$navItems.forEach((item) => {
      item.removeEventListener('click', this.onClick.bind(this));
    });
    this.ui = {};
  }

  bindUI() {
    this.ui = {};
    this.ui.$navItems = [...this.element.querySelectorAll('.js-nav-item')];
  }

  bindEvents() {
    this.ui.$navItems.forEach((item) => {
      item.addEventListener('click', this.onClick.bind(this));
    });
  }


  onClick() {
    this.ui.$navItems.forEach((item) => {
      item.addEventListener('click', this.onClick.bind(this));
      if (document.documentElement.classList.contains('menu-active')) {
        const toggles = document.querySelectorAll('.js-checkbox-toggle');
        toggles.forEach((toggle) => {
          toggle.checked = false;
        });
      }
    });
  }
}

export default Menu;
